/* eslint-disable react/prop-types */
import React from 'react';
// import { replaceToLowerCase } from 'shared/modules';

import {
  buildSearchAvtoSeoHeader,
  buildDealersSeoHeader,
  buildSparePartsSeoHeader,
  buildFirmsSeoHeader,
  buildCommercialSeoHeader,
} from 'shared/helpers/seoHeaders';
import { getSeoDataByParams } from 'shared/helpers/seoTextFinder';

const buildPageEnding = (page, t) => (page > 1 ? ` - ${t('страница')} ${page}` : '');

const buildMakeSearchLink = query =>
  query.transportHeader && query.make
    ? <React.Fragment>
        {query.make.title}
      </React.Fragment>
    : '';

const buildModelSearchLink = query =>
  query.transportHeader && query.make && query.model
    ? <React.Fragment>
        {query.model.title}
      </React.Fragment>
    : '';

const buildCategorySearchLink = query =>
  query.transportHeader && query.category
    ? <React.Fragment>
        {query.category.title}
      </React.Fragment>
    : '';

const buildEngineSearchLink = query =>
  query.transportHeader && query.engine
    ? <React.Fragment>
        {query.engine.title}
      </React.Fragment>
    : '';

const buildGearboxSearchLink = query =>
  query.transportHeader && query.gearbox
    ? <React.Fragment>
        {query.gearbox.title}
      </React.Fragment>
    : '';

const buildLocationSearchLink = query =>
  query.transportHeader && query.location && query.locationObj
    ? <React.Fragment>
        {query.location}
      </React.Fragment>
    : '';

const buildYearSearchLink = query =>
  query.transportHeader && query.yearFrom && query.yearTo && query.yearFrom === query.yearTo
    ? <React.Fragment>
        {query.yearTo}
      </React.Fragment>
    : '';

const buildAddHeaderByTransportSlug = (slug, t) => {
  let transportHeader = 'автомобиля';
  switch (slug) {
    case 'moto': {
      transportHeader = 'мототехники';
      break;
    }
    case 'avtobus': {
      transportHeader = 'автобуса';
      break;
    }
    case 'gruzovye': {
      transportHeader = 'грузовика';
      break;
    }
    case 'spetstehnika': {
      transportHeader = 'спецтехники';
      break;
    }
    case 'pritsepy': {
      transportHeader = 'прицепа';
      break;
    }
    case 'vodnyi-transport': {
      transportHeader = 'водного транспорта';
      break;
    }
    case 'zapchasti': {
      transportHeader = 'автозапчастей';
      break;
    }

    default: {
      break;
    }
  }

  return `${t('Разместить объявление о продаже')} ${t(transportHeader)}`;
};
export const buildSearchHeaderByType = transportSlug => (data, t) => {
  const seoData = getSeoDataByParams(data, t);
  if (seoData && seoData.header) return seoData.header;
  const {
    isNew = false,
    //
    category = '',
    gearbox = '',
    engine = '',
    //
    type = '',
    make = '',
    model = '',
    modification = '',
    location,
    country,
    transportHeader,
    locationObj,
    yearFrom,
    yearTo,
    motoHeader,
    page = 1,
    yearTitle,
  } = data;
  const categoryLink =
    category && category.title ? buildCategorySearchLink({ isNew, transportHeader, category }) : '';
  const engineLink = engine ? buildEngineSearchLink({ isNew, transportHeader, engine }) : '';
  const makeLink = buildMakeSearchLink({ isNew, transportHeader, make });
  const modelLink = buildModelSearchLink({ isNew, transportHeader, make, model });
  const gearboxLink = gearbox ? buildGearboxSearchLink({ isNew, transportHeader, gearbox }) : '';
  const yearLink = buildYearSearchLink({
    transportHeader,
    make,
    model,
    isNew,
    yearFrom,
    yearTo,
  });
  const locationLink = location
    ? buildLocationSearchLink({
        transportHeader,
        make,
        model,
        location,
        locationObj,
        isNew,
      })
    : t('в Украине');

  const commonLinksComponent = (
    <span>
      {makeLink} {modelLink} {modification && `${modification.title} `} {gearboxLink} {yearTitle}
      {locationLink}
    </span>
  );
  const commonLinks = commonLinksComponent.props.children;

  switch (transportSlug) {
    case 'avto': {
      if (country) {
        return (
          <span>
            <React.Fragment>
              {t('Купить')} {!makeLink && !modelLink && t('авто')}
            </React.Fragment>{' '}
            {makeLink} {modelLink} {country}
            {buildPageEnding(page, t)}
          </span>
        );
      } else if (isNew) {
        return (
          <span>
            <React.Fragment>
              {t('Купить новые')} {!makeLink && !modelLink && t('авто')}
            </React.Fragment>{' '}
            {makeLink} {modelLink} {locationLink}
            {buildPageEnding(page, t)}
          </span>
        );
      }

      return (
        <span>
          <React.Fragment>
            {t('Купить')} {t('авто')}
          </React.Fragment>{' '}
          {categoryLink}
          {makeLink} {modelLink} {engineLink} {gearboxLink} {yearLink} {yearLink && t('года')}{' '}
          {locationLink}
          {buildPageEnding(page, t)}
        </span>
      );
    }

    case 'mototsikl': {
      if (motoHeader) {
        return (
          <span>
            <React.Fragment>
              {t('Купить')} {motoHeader}
            </React.Fragment>{' '}
            {categoryLink} {commonLinks}
            {buildPageEnding(page, t)}
          </span>
        );
      } else if (isNew) {
        return (
          <span>
            <React.Fragment>{t('Купить новый мотоцикл')}</React.Fragment> {categoryLink}{' '}
            {commonLinks}
            {buildPageEnding(page, t)}
          </span>
        );
      }
      return (
        <span>
          <React.Fragment>{t('Купить мотоцикл')}</React.Fragment> {categoryLink} {commonLinks}
          {buildPageEnding(page, t)}
        </span>
      );
    }
    case 'moto': {
      if (motoHeader) {
        return (
          <span>
            <React.Fragment>
              {t('Купить')} {motoHeader}
            </React.Fragment>{' '}
            {categoryLink} {commonLinks}
            {buildPageEnding(page, t)}
          </span>
        );
      } else if (isNew) {
        return (
          <span>
            <React.Fragment>
              {t('Купить')} {!category && !type ? t('новую') : t('новый')}{' '}
              {!category && !type && t('мототехнику')} {type ? type.title.toLowerCase() : ''}
            </React.Fragment>{' '}
            {categoryLink} {commonLinks}
            {buildPageEnding(page, t)}
          </span>
        );
      }
      return (
        <span>
          <React.Fragment>
            {t('Купить')} {!category && !type && t('мототехнику')}{' '}
            {type ? type.title.toLowerCase() : ''}
          </React.Fragment>{' '}
          {categoryLink} {commonLinks}
          {buildPageEnding(page, t)}
        </span>
      );
    }
    case 'avtobus':
      return (
        <span>
          {t('Купить')} {categoryLink} {t('автобус')} {commonLinks}
          {buildPageEnding(page, t)}
        </span>
      );
    case 'gruzovye':
      return (
        <span>
          <React.Fragment>
            {t('Купить')} {!engine && !category && `${t('грузовик')} `}
          </React.Fragment>{' '}
          {categoryLink} {engineLink}
          {commonLinks}
          {buildPageEnding(page, t)}
        </span>
      );
    case 'spetstehnika':
      return (
        <span>
          <React.Fragment>
            {t('Купить')} {!categoryLink && t('спецтехнику')}
          </React.Fragment>{' '}
          {categoryLink} {commonLinks}
          {buildPageEnding(page, t)}
        </span>
      );
    case 'pritsepy':
      return (
        <span>
          <React.Fragment>
            {t('Купить')} ${!category && !type && !engineLink && t('автоприцеп')}
          </React.Fragment>
          {(category || type || engineLink) &&
            <span>
              {categoryLink} {type ? type.title.toLowerCase() : ''}
              {engineLink}{' '}
            </span>}{' '}
          {commonLinks}
          {buildPageEnding(page, t)}
        </span>
      );
    default:
      return '';
  }
};
const META_HEADER = {
  ADVERT_FORM: {
    ADD: (slug, t) => buildAddHeaderByTransportSlug(slug, t),
  },
  HOME: (hull, t) => [`${t('Автобазар')}™`, '–', t('Все машины тут')].join(' '),
  DEALERS: (data, slug, t) => buildDealersSeoHeader(data, slug, t),
  FIRM: (data, t) => buildFirmsSeoHeader(data, t),

  MOTO: ({ location, locationWhere }, t) =>
    `${t('Купить')} ${t('мототехнику')} ${t(locationWhere) || t('в Украине')}`,

  //

  SEARCH: {
    avto: (data, translate) => buildSearchAvtoSeoHeader(data, translate),
    mototsikl: (props, translate) => buildSearchHeaderByType('mototsikl')(props, translate),
    moto: (props, translate) => buildSearchHeaderByType('moto')(props, translate),
    commercial: (params, t) => buildCommercialSeoHeader(params, t),
  },
  SPARE_PARTS: (data, rubricSlug, t, isRegion) =>
    buildSparePartsSeoHeader(data, rubricSlug, t, isRegion),

  SERVICE: {
    CAR_DRIVE: t => `${t('Пригон авто')} ${t('на Автобазаре')}`,
  },
};

export default META_HEADER;



// WEBPACK FOOTER //
// ./src/shared/constants/seoHeaders.js